import React, { useEffect, useState } from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'

import ToastComponent from 'src/components/common/TaostComponent.js'
import FixturesTable from 'src/components/common/FixturesTable'

// Read-only fixtures list opened from the "Fixtures" count on the teams and rounds listings.
// `loadFixtures` fetches the rows (team schedule or round fixtures); `sourceId` refetches
// when a different row is opened. The table itself is shared with the Edit Team panel.
const FixturesModal = ({
  title,
  sourceId,
  loadFixtures,
  visible,
  onClose,
  emptyLabel = 'No fixtures yet.',
}) => {
  const [fixtures, setFixtures] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!visible || !sourceId) return undefined

    let cancelled = false
    setFixtures([])
    setLoading(true)
    loadFixtures(sourceId)
      .then((res) => {
        if (cancelled) return
        if (res.status === 200) {
          setFixtures(res.data || [])
        } else {
          ToastComponent(res.message || 'Unable to load fixtures.', 'error')
        }
      })
      .catch(() => {
        if (!cancelled) ToastComponent('Unable to load fixtures.', 'error')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, sourceId])

  return (
    <CModal visible={visible} onClose={onClose} size="xl" alignment="center">
      <CModalHeader>
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <FixturesTable fixtures={fixtures} loading={loading} emptyLabel={emptyLabel} />
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Close
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default FixturesModal
